export default class ImgLazyLoader {

    timeout = null;
    delay = 20;
    additionalOffset = 450;
    container = null;
    images = [];

    constructor(container = null) {
        this.container = container ?? document;
        if (this.container.scrollHeight <= this.container.clientHeight) {
            this.container = document;
        }
        this.init();
    }

    init = () => {
        this.images = this.container.querySelectorAll("img.lazy");
        this.load();
        this.container.addEventListener("scroll", this.load);
        window.addEventListener("resize", this.load);
        window.addEventListener("orientationChange", this.load);
    }

    load = () => {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            const offsetHeight = this.container === document ? window.scrollY + window.innerHeight : this.container.offsetHeight + this.additionalOffset;

            this.images.forEach(async (img) => {
                if (!img.classList.contains('lazy')) {
                    return;
                }

                if (img.getBoundingClientRect().top < (offsetHeight)) {
                    this.imageExists(img.dataset.src, (exists) => {
                        if (exists) {
                            img.src = img.dataset.src;
                        }
                        img.classList.remove('lazy');
                    });
                }
            });

            if (this.images.length == 0) {
                this.container.removeEventListener("scroll", this.load);
                window.removeEventListener("resize", this.load);
                window.removeEventListener("orientationChange", this.load);
            }
        }, this.delay);
    }

    imageExists = (url, callback) => {
        const img = new Image();
        img.src = url;

        if (img.complete) {
            callback(true);
        } else {
            img.onload = () => {
                callback(true);
            };

            img.onerror = () => {
                callback(false);
            };
        }
    }

    singleImageLoad = (imgElement) => {
        this.imageExists(imgElement.dataset.src, (exists) => {
            if (exists) {
                imgElement.src = imgElement.dataset.src;
            }
            imgElement.classList.remove('lazy');
        });
    }
}